import { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { FormService } from "../../../services/cms/form";
import FormTable from "./form-table";
import LoadingText from "../../../components/Text/loading";
import Title from "../../../components/Title";
import { FormattedMessage, useIntl } from "react-intl";

function FormList() {
  const { name } = useParams();
  const intl = useIntl();

  const navigate = useNavigate();

  const { data, isLoading } = useQuery(["formList"], () => {
    return FormService.getList({});
  });

  useEffect(() => {
    if (!name && !isLoading && data && data.data.length > 0) {
      navigate(`/cms/forms/${data.data[0].name}`);
    }
  }, [name, isLoading, data]);

  const type = data?.data.find((t: any) => t.name === name);

  if (data && !data.data.length) {
    return (
      <>
        <Title
          subText={intl.formatMessage(
            { id: "You have a total of N forms." },
            { number: data?.pagination?.total || 0 },
          )}
        >
          <FormattedMessage id="Form List" />
        </Title>

        <div className="card card-bordered card-preview">
          <div className="card-inner">
            <div className="text-center my-4">
              <h6 className="mt-2">
                <FormattedMessage id="No forms found" />
              </h6>
              <p className="text-muted">
                <FormattedMessage id="No forms found" />.{" "}
                <FormattedMessage id="Please contact support." />
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Title
        subText={intl.formatMessage(
          { id: "You have a total of N forms." },
          { number: data?.pagination?.total || 0 },
        )}
      >
        <FormattedMessage id="Form List" />
      </Title>

      <div className="card card-bordered card-preview">
        <div className="card-inner">
          <Tabs
            id="controlled-tab-example"
            className="nav nav-tabs mt-n3"
            role="tablist"
            activeKey={name}
            onSelect={(k) => navigate(`/cms/forms/${k}`)}
          >
            {!isLoading
              ? data?.data.map((t: any, i: number) => {
                  return (
                    <Tab
                      eventKey={t.name}
                      role="presentation"
                      className="nav-item"
                      key={i}
                      title={t.displayName}
                    />
                  );
                })
              : [1, 2].map((k) => (
                  <Tab
                    role="presentation"
                    className="nav-item"
                    key={k}
                    title={<LoadingText />}
                  />
                ))}
          </Tabs>
          <TabContainer type={type} loading={isLoading} />
        </div>
      </div>
    </>
  );
}

const TabContainer: React.FC<{
  type?: any;
  loading: boolean;
}> = ({ type, loading }) => {
  return (
    <FormTable
      name={type?.name}
      apiId={type?.apiId}
      displayName={type?.displayName}
      schema={type?.schema?.attributes}
      loading={loading}
      baseUrl={type?.link}
    />
  );
};

export default FormList;
